<div class="wrapper">
  @if (!options?.hideHeader && !options?.hideHeading) {
    <div class="heading text-type-2">{{ data?.bidItem?.item }}</div>
  }
  @if (options?.showSiteAndDate && (data?.siteName || data?.reportDate)) {
    <div class="site-report-info">
      {{ data?.siteName }}@if (data?.siteName && data?.reportDate) {
      <span> • </span>
      }{{ data?.reportDate | date: 'MMMM dd, yyyy' }}
    </div>
  }
  <div class="description text-type-10">{{ data?.bidItem?.description }}</div>

  @if (data?.stations !== undefined) {
    <app-station-wise-bid-item-details
      [bidItem]="data?.bidItem"
      [heading]="data?.heading"
      [stationsList]="data?.stations"
      />
  }
  @if (data?.lineItems !== undefined) {
    <app-multiline-bid-item-details
      [bidItem]="data?.bidItem"
      [clickId]="data?.clickId"
      [disabled]="options?.disabled"
      [lineItems]="data?.lineItems"
      [showMiniMaps]="options?.showMiniMaps !== false"
      [highlightFeatureIndex]="data?.highlightFeatureIndex"
      [mapMode]="options?.mapMode === true"
      />
  }
  @if (options?.showActionsSection === undefined || options?.showActionsSection) {
    <app-actions-section
      [disableAddMenu]="disableAddMenu"
      [disableDelete]="data?.isAnyLinePaid"
      locationStationToolbarContext="bid_items"
      class="actions-section w-[455px]"
      />
  }
</div>
